export default function ReferEmailIcon() {
  return (
    <svg
      width="37"
      height="36"
      viewBox="9.691 10.004 36.513 36.096"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_10402_5122)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.4099 10.001C37.018 10.001 38.8216 10.001 40.7639 10.616C42.8843 11.3891 44.5544 13.0618 45.3262 15.1858C45.9401 17.131 45.9401 18.9382 45.9401 22.5519V33.4496C45.9401 37.0636 45.9401 38.8702 45.3262 40.8157C44.5544 42.9397 42.8843 44.6124 40.7639 45.3852C38.8216 46.0005 37.018 46.0005 33.4099 46.0005H22.5302C18.9221 46.0005 17.1182 46.0005 15.1763 45.3852C13.0558 44.6124 11.3858 42.9397 10.614 40.8157C10 38.8702 10 37.0636 10 33.4496V22.5519C10 18.9382 10 17.131 10.614 15.1858C11.3858 13.0618 13.0558 11.3891 15.1763 10.616C17.1182 10.001 18.9221 10.001 22.5302 10.001H33.4099Z"
          fill="#8065C9"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.5042 35.7808C39.4549 35.794 39.4031 35.8011 39.3497 35.8011H16.5862C16.5327 35.8011 16.4809 35.794 16.4316 35.7808L23.5283 28.6763L25.0351 30.2225C26.6538 31.8835 29.282 31.8836 30.9008 30.2225L32.4076 28.6763L39.5042 35.7808ZM39.9502 35.0221V20.9294C39.9502 20.8575 39.9375 20.7885 39.9143 20.7246C39.8789 20.8067 32.8281 28.0675 32.8281 28.0675L39.9299 35.1772C39.9431 35.1278 39.9502 35.0758 39.9502 35.0221ZM15.9902 35.0817V20.9889C15.9902 20.9171 16.0029 20.8481 16.0261 20.7843C16.0615 20.8663 23.1123 28.1271 23.1123 28.1271L16.0105 35.2369C15.9973 35.1874 15.9902 35.1354 15.9902 35.0817ZM39.5331 20.2125L30.4719 29.5032C29.0882 30.9231 26.8474 30.923 25.4638 29.5032C25.4638 29.5032 19.424 23.3104 16.4041 20.214C16.3767 20.186 39.5331 20.2125 39.5331 20.2125Z"
          fill="white"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_10402_5122"
          x="0"
          y="0.000976562"
          width="55.9395"
          height="55.9995"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="5"></feGaussianBlur>
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          ></feColorMatrix>
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10402_5122"
          ></feBlend>
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10402_5122"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}
